import { render, staticRenderFns } from "./instructionProofList.vue?vue&type=template&id=5f9e1ab8"
import script from "./instructionProofList.vue?vue&type=script&lang=js"
export * from "./instructionProofList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports